import React, { useState } from 'react';
import { makeStyles, Theme, useTheme, colors } from '@material-ui/core';
import { Typography, Link } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';


interface IProps {
    onDropCallback: (acceptedFiles: any) => any
    isMultiple: boolean,
    accept?: string[] | string
}

let useStyles = makeStyles((theme: Theme) => ({
    dropzone: {
        border: `2px dashed #560604`,
        padding: theme.spacing(3),
        outline: 'none',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        '&:hover': {
            backgroundColor: colors.grey[50],
            opacity: 0.5,
            cursor: 'pointer'
        }
    },
    dragActive: {
        backgroundColor: colors.grey[50],
        opacity: 0.5
    },
    info: {
        marginTop: theme.spacing(1),
    }
}));

let Dropzone = (props: IProps) => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let [errorMessage, setErrorMessage] = useState('');

    let { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: props.onDropCallback,
        multiple: props.isMultiple,
        accept: props.accept,
        onDropAccepted: () => setErrorMessage(''),
        onDropRejected: (files) => setErrorMessage(`These files could not be uploaded:${files.map(f => ` ${f.file.name}`)}`)
    });


    return (
        <>
            <div
                className={
                    clsx({
                        [classes.dropzone]: true,
                        [classes.dragActive]: isDragActive
                    })
                }
                {...getRootProps()}
            >
                <input {...getInputProps()} />

                <div>
                    <Typography gutterBottom variant="h3">Select files</Typography>
                    <Typography
                        className={classes.info}
                        color="textSecondary"
                        variant="body1"
                    >
                        Drop file here or click and <Link underline="always">browse</Link> thorough your machine
                </Typography>
                </div>

            </div>
            {errorMessage !== '' &&
                <Alert style={{ marginTop: 20 }} severity="error">
                    <AlertTitle>
                        {props.accept &&
                            Array.isArray(props.accept)
                            ? `Only${props.accept.map(accept => ` ${accept}`)} are allowed.`
                            : `Only ${props.accept} files are allowed`
                        }
                    </AlertTitle>
                    {errorMessage}
                </Alert>
            }
        </>
    )
}

export default Dropzone;